module.exports = __webpack_public_path__ + "img/BlackMetallic_B.a003f718.png";